<template>
  <div>
    <v-container fluid>

      <v-snackbar v-model="alert" centered color="success" timeout="800" top>
        <v-icon dark left>mdi-check-circle</v-icon>
        Copié dans le presse-papier.
      </v-snackbar>

      <div class="main">
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between mb-3">
              <v-spacer/>

              <v-btn class="rounded-lg"
                     color="gifty"
                     @click="openDialog"
                     dark
                     depressed
              >
                <v-icon left>mdi-import</v-icon>
                Importer
              </v-btn>
            </div>

            <v-card class="rounded-lg shadow">
              <v-overlay :value="overlay" absolute color="white" opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      @keydown.enter="getData"
                      hint="Appuyez sur ↵ Entrée pour rechercher"
                      clearable
                      @click:clear="[keyword=null,getData()]"
                      dense
                      filled
                      persistent-hint
                      placeholder="Recherche..."
                      rounded
                  ></v-text-field>
                </div>

                <v-spacer/>

                <v-btn color="grey"
                       text
                       @click="getData">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

                <v-btn color="grey"
                       :loading="exportLoading"
                       text
                       @click="exportData">
                  <v-icon left>mdi-export</v-icon>
                  Exporter
                </v-btn>

                <v-btn color="grey"
                       text
                       @click="getData">
                  <v-icon left>mdi-filter-outline</v-icon>
                  Filtrer
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text>
                  <v-simple-table class="table-border rounded-lg" v-if="packs.length">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Code</th>
                        <th>Type de pack</th>
                        <th>Solde globale(Refill)</th>
                        <th>Solde globale(Multiservices)</th>
                        <th>Solde à crédit(Multiservices)</th>
                        <th>Carte Multiservices</th>
                        <th>Scané?</th>
                        <th class="text-no-wrap">Scané le</th>
                        <th>Vendu?</th>
                        <th class="text-no-wrap">Vendu le</th>
                        <th class="text-no-wrap">Compte POS</th>
                        <th>Date d'expiration</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item ,index) in packs" :key="index">

                        <td class="font-weight-medium gifty-text">
                          {{ item.code }}
                        </td>

                        <td>
                          <v-chip color="info" small>
                            <v-icon small left>mdi-tag-outline</v-icon>
                            {{ item.type === "card_refill" ? "Refill" : "Multiservice" }}
                          </v-chip>
                        </td>

                        <td class="font-weight-medium">
                          {{ item.global_balance ?? "-" }}
                        </td>

                        <td class="font-weight-medium">
                          {{ item.card_balance ?? "-" }}
                        </td>

                        <td class="font-weight-medium">
                          {{ item.card_credit_balance ?? "-" }}
                        </td>

                        <td class="text-no-wrap">
                          {{ item.account_card_template?.name ?? "-" }}
                        </td>

                        <td>
                          <v-icon v-if="item.is_used" color="success">mdi-check-circle</v-icon>
                          <v-icon v-else color="orange">mdi-timer-sand</v-icon>
                        </td>

                        <td class="font-weight-medium">
                          {{ item.used_at ?? "-" }}
                        </td>

                        <td>
                          <v-icon v-if="item.is_purchased" color="success">mdi-check-circle</v-icon>
                          <v-icon v-else color="orange">mdi-timer-sand</v-icon>
                        </td>

                        <td class="font-weight-medium">
                          {{ item.purchased_at ?? "-" }}
                        </td>

                        <td>
                          {{ item.account_card?.account?.user?.name ?? "-" }}
                        </td>


                        <td class="font-weight-medium">
                          {{ item.experation_date ?? "-" }}
                        </td>

                        <td>
                          <v-btn icon @click="remove(item.id)" color="gifty">
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </td>

                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div v-else>
                    <NoResults @reload="getData"/>
                  </div>

                </v-card-text>
                <v-divider/>

                <v-card-actions>

                  <div :style="{width: '120px'}">
                    <v-select v-model="perPage"
                              :items="[10,20,30,50,100]"
                              dense
                              hide-details
                              label="Ligne par page"
                              outlined></v-select>
                  </div>

                  <v-spacer/>


                  <span class="text--darken-2 grey--text">
                      {{ pageStart }}-{{ pageEnd }} de {{ total }}
                  </span>
                  <v-pagination v-model="pagination.current"
                                :length="pagination.total"
                                circle
                                total-visible="8"
                                @input="getData"></v-pagination>

                </v-card-actions>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-dialog v-model="dialog" width="600" persistent scrollable>
        <v-card :loading="btnLoading" :disabled="btnLoading">
          <v-card-title>
            Importer
            <v-spacer/>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-8">
            <v-alert text type="info">
              Le premier colonne de votre fichier Excel doit être l'en-tête.
              Assurez-vous que le fichier est au format .xlsx ou .csv.
            </v-alert>
            <v-file-input outlined
                          dense
                          ref="file"
                          label="Fichier Excel *"
                          @change="excelFile($event)"
                          :error-messages="errors.file"
                          hide-details="auto"
                          accept=".xlsx, .csv"/>

            <v-checkbox
                v-model="deleteNotExist"
                label="Supprimer les codes non incluses dans le nouveau fichier"
            />


            <v-radio-group v-model="type" label="Type de pack *" row>
              <v-radio label="Carte refill" value="card_refill"></v-radio>
              <v-radio label="Carte multiservices" value="card_multiservices"></v-radio>
            </v-radio-group>

            <v-select outlined
                      v-if="type === 'card_multiservices'"
                      :items="templates"
                      v-model="account_card_template_id"
                      item-value="id"
                      item-text="name"
                      dense
                      hide-details="auto"
                      label="Carte Multiservices*"
                      :error-messages="errors.account_card_template_id"
            />


            <v-text-field outlined
                          v-if="type === 'card_refill'"
                          dense
                          label="Montant *"
                          v-model="global_balance"
                          :error-messages="errors.global_balance"
            />

            <v-row v-if="type === 'card_multiservices'">
              <v-col cols="12">
                <v-checkbox
                    v-model="is_global_default"
                    label="Solde global par défaut"
                    color="primary"
                    hide-details
                ></v-checkbox>
              </v-col>

              <v-col cols="6">
                <v-text-field
                    outlined
                    label="Solde globale"
                    dense
                    :disabled="!is_global_default"
                    :error-messages="errors.card_balance"
                    v-model="card_balance"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                    outlined
                    label="Solde à crédit"
                    dense
                    :disabled="is_global_default"
                    :error-messages="errors.card_credit_balance"
                    v-model="card_credit_balance"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
                outlined
                label="Date d'expiration *"
                dense
                hide-details="auto"
                type="date"
                :error-messages="errors.experation_date"
                v-model="experation_date"
            ></v-text-field>

          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="gifty" dark depressed @click="upload" :loading="btnLoading">
              <v-icon left>mdi-import</v-icon>
              Importer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";

export default {
  components: {NoResults},
  data() {
    return {
      exportLoading: false,
      id: '',
      keyword: '',
      type: 'card_refill',
      account_card_template_id: '',
      global_balance: '',
      experation_date: '',
      is_global_default: true,
      card_balance: '',
      card_credit_balance: '',
      dialog: false,
      btnLoading: false,
      overlay: false,
      isLoading: false,
      alert: false,
      deleteNotExist: false,
      file: null,
      errors: {},
      templates: [],
      packs: [],
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    openDialog() {
      this.dialog = true
      this.$refs.file?.reset()
      this.errors = {}
      this.deleteNotExist = false
    },
    excelFile(file) {
      this.file = file
    },
    upload() {
      this.btnLoading = true
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('delete_not_exist', this.deleteNotExist ? 1 : 0)
      formData.append('account_card_template_id', this.account_card_template_id ?? "")
      formData.append('global_balance', this.global_balance ?? "")
      formData.append('is_global_default', this.is_global_default ? 1 : 0)
      formData.append('card_balance', this.card_balance ?? "")
      formData.append('card_credit_balance', this.card_credit_balance ?? "")
      formData.append('type', this.type)
      formData.append('experation_date', this.experation_date ?? "")

      HTTP.post('/v1/pos-packs/import', formData).then(() => {
        this.btnLoading = false
        this.$successMessage = "Fichier importé avec succès!";
        this.dialog = false;
        this.getData();
      }).catch(err => {
        this.btnLoading = false
        this.errors = err.response.data.errors
        console.log(err)
      })
    },
    async copy(text) {
      this.alert = false
      try {
        await navigator.clipboard.writeText(text);
        this.alert = true
      } catch ($e) {
        console.log($e)
      }
    },
    getData() {
      this.isLoading = true
      HTTP.get('/v1/pos-packs?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword
        }
      }).then(res => {

        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

        this.packs = res.data.data.data

        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/pos-packs/delete", {
        id: this.id,
      }).then(() => {
        this.overlay = false;
        let i = this.packs.findIndex((el) => el.id === this.id);
        this.$delete(this.packs, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    getTemplates() {
      HTTP.get('/v1/account-cards/templates').then(res => {
        this.templates = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    exportData() {
      this.exportLoading = true
      HTTP.post('/v1/pos-packs/export', {}, { responseType: 'blob' })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const a = document.createElement('a')
            a.href = url
            a.download = 'pos_packs.xlsx'
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
            this.exportLoading = false
          })
          .catch((err) => {
            console.error('Erreur export:', err)
            this.exportLoading = false
          })
    }

  },
  created() {
    this.getData();
    this.getTemplates();
  },
  computed: {
    pageStart() {
      if (this.total === 0) return 0
      return (this.pagination.current - 1) * this.perPage + 1
    },
    pageEnd() {
      let end = this.pagination.current * this.perPage
      return end > this.total ? this.total : end
    }
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
    perPage() {
      this.pagination.current = 1
      this.getData();
    },
    keyword() {
      this.getData();
    },
  }
};
</script>

<style scoped></style>
